export const lockTypeConfig = {
  heading: "Serrature e accessi",
  subtitle:
    "Come entra l'ospite nella tua struttura? Aggiungi una o più serrature (ingresso dell'edificio, unità…), ciascuna con il proprio nome e tipo di accesso.",
  loading: "Caricamento della configurazione…",

  enable: {
    title: "Invia i codici di accesso",
    sub:
      "Se disattivi questa opzione non invieremo le chiavi di accesso all'ospite. Le istruzioni per l'arrivo verranno comunque inviate indipendentemente da questa impostazione.",
  },

  scope: {
    labelRoom: "Stanza da configurare",
    labelUnit: "Unità da configurare",
    hintRoom: "Ogni stanza mantiene la propria configurazione di accesso.",
    hintUnit: "Ogni unità mantiene la propria configurazione di accesso.",
  },

  conflict: {
    title: "Questi spazi non useranno questa configurazione",
    textBefore:
      "Mantengono le proprie chiavi e, al momento dell'invio, prevale sempre la configurazione più specifica.",
    textStrong: "Ciò che modifichi qui non li raggiungerà",
    textAfter: "finché restano così:",
    lockCount: "serratura | serrature",
    applying: "Applicazione…",
    applyAll: "Applica questa configurazione a tutti",
  },

  lockBadge: "Serratura {n}",
  removeLock: "Rimuovi serratura",
  nameLabel: "Nome dell'ingresso",
  namePlaceholder: "Oppure digita un nome…",
  typeLabel: "Tipo di accesso",
  codePlaceholderBox: "Codice della cassetta portachiavi · es. 5817",
  codePlaceholderLock: "Codice della serratura · es. 5817",
  lockFallback: "Serratura",
  connectedSuffix: "connessa",
  editConfig: "Modifica configurazione",
  configure: "Configura…",
  addLock: "Aggiungi un'altra serratura",
  roomsHint:
    "Ogni stanza fisica ha la propria serratura e il proprio codice. Configurale qui, una per una.",

  wa: {
    online: "online",
    today: "Oggi",
    captionOverriding: "Ecco come lo riceve {source} · non gli spazi indicati sopra",
    captionPreview: "Anteprima · ecco come lo riceverà l'ospite di {source}",
  },

  modal: {
    title: "Configura la tua serratura intelligente",
    sub: "Scegli la tua marca e collegala per generare chiavi automatiche per ogni prenotazione.",
    close: "Chiudi",
    note: "Aggiungi prima un'unità all'annuncio per configurare la serratura intelligente.",
  },

  providerOther: "Altra marca",

  presets: {
    main: "Ingresso principale",
    property: "Ingresso della struttura",
    unit: "Ingresso dell'unità",
  },

  entryFallback: "Ingresso",
  roomFallback: "Stanza",
  yourProperty: "la tua struttura",

  types: {
    none: {
      title: "Cassetta portachiavi",
      desc: "Una cassetta di sicurezza con le chiavi della struttura.",
    },
    dynamic: {
      title: "Serratura intelligente",
      desc: "Una nuova chiave automatica per ogni prenotazione.",
    },
    static: {
      title: "Serratura con codice fisso",
      desc: "Un codice che cambi manualmente di tanto in tanto.",
    },
  },

  source: {
    room: "questa stanza",
    unit: "questa struttura",
    property: "l'annuncio",
  },

  preview: {
    boxText:
      "🔑 *{label} · {name}*\n\nLa cassetta portachiavi si apre con il codice: *{code}*\n\nAll'interno troverai le chiavi della struttura. Ti preghiamo di lasciarle nuovamente lì quando parti.",
    dynamicText:
      "🔒🔑 *{label} · {name}*\n\nIl tuo codice di accesso è: *58117*\n\nValido per tutto il tuo soggiorno.",
    staticText:
      "🔒🔑 *{label} · {name}*\n\nIl codice della serratura è: *{code}*\n\nUsalo per aprire la porta della struttura.",
  },

  summary: {
    dynamic: "Serratura intelligente",
    codePrefix: "Codice {code}",
    staticCode: "Codice fisso",
    boxPrefix: "Cassetta portachiavi {code}",
    empty: "Non configurato",
  },

  toast: {
    saved: "Accesso salvato",
    saveError: "Impossibile salvare il metodo di accesso.",
    unified: "Configurazione unificata",
    unifyError: "Impossibile unificare la configurazione.",
    savedRoom: "Accesso salvato · {room}",
    saveErrorRoom: "Impossibile salvare l'accesso per {room}.",
    theRoom: "la stanza",
  },
};
